// src/theme/ThemeProvider.tsx
import React from 'react';
import { ThemeProvider as StyledThemeProvider, createGlobalStyle } from 'styled-components';
import { colours } from './colours';
import { typography } from './typography';

// Define the theme
export const theme = {
  colours,
  typography,
  spacing: (multiplier: number) => `${multiplier * 8}px`,
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    round: '50%'
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.1)',
    large: '0 8px 24px rgba(0, 0, 0, 0.1)'
  },
  transitions: {
    short: '0.2s',
    medium: '0.3s',
    long: '0.5s'
  }
};

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'HK Nova';
    src: url('/fonts/HKNova/HKNova-Regular.otf') format('opentype'),
         url('/fonts/HKNova/HKNova-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'HK Nova';
    src: url('/fonts/HKNova/HKNova-Medium.otf') format('opentype'),
         url('/fonts/HKNova/HKNova-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'HK Nova';
    src: url('/fonts/HKNova/HKNova-SemiBold.otf') format('opentype'),
         url('/fonts/HKNova/HKNova-SemiBold.otf') format('opentype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'HK Nova';
    src: url('/fonts/HKNova/HKNova-Bold.otf') format('opentype'),
         url('/fonts/HKNova/HKNova-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: ${theme.typography.fontFamily};
    background-color: ${theme.colours.background.default};
    color: ${theme.colours.text.primary};
    line-height: 1.5;
  }
  
  a {
    color: ${theme.colours.primary.main};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  button {
    cursor: pointer;
    font-family: ${theme.typography.fontFamily};
  }
`;

export type ThemeType = typeof theme;

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  );
};
